/** Отчёт обработки лидов — ровно то, что отдаёт `GET /api/leads/report`. */
import { apiFetch, query } from "@/lib/api";

export type Count = { name: string; count: number };

export type MissedLead = {
  lead_id: number;
  created: string;
  source: string;
  phone: string;
  status: string;
  status_name: string;
  next_work: string | null;
  first_out: string | null;
  first_in_answered: string | null;
  talked_in_time: boolean;
};

export type LeadReport = {
  day: string;
  work_hours: string;
  new_leads: { total: number; by_source: Count[]; by_status_group: Count[] };
  incoming: { total: number; answered: number; missed: number; unique_phones: number; with_lead: number };
  first_call: {
    count: number;
    mean: number | null;
    median: number | null;
    p90: number | null;
    leads: number;
    without_call: number;
  };
  coverage: {
    window_from: string;
    window_to: string;
    total: number;
    without_phone: number;
    called: number;
    all_called: boolean;
    processed: number;
    all_processed: boolean;
    missed_by_source: Count[];
    missed_with_incoming_talk: number;
    missed: MissedLead[];
  };
};

export function loadLeadReport(day: string): Promise<LeadReport> {
  return apiFetch<LeadReport>(`/api/leads/report${query({ date: day })}`);
}

/** Рабочие минуты по-человечески: 65 → «1 ч 05 мин». */
export function workTime(minutes: number | null): string {
  if (minutes === null) return "—";
  const total = Math.round(minutes);
  const h = Math.floor(total / 60);
  const m = total % 60;
  return h ? `${h} ч ${String(m).padStart(2, "0")} мин` : `${m} мин`;
}

/** «2026-09-23T14:37:39» → «23.09 14:37». Время CRM — московское, как есть. */
export function shortTime(iso: string | null): string {
  if (!iso) return "—";
  return `${iso.slice(8, 10)}.${iso.slice(5, 7)} ${iso.slice(11, 16)}`;
}

/** Вчера по локальному календарю, ГГГГ-ММ-ДД. */
export function yesterday(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
